export default __webpack_public_path__ + "static/writing-de@2x-0f2892b6bf4294798c6da37f254e4526.png";